<template>
  <nav class="navbar navbar-expand-md navbar-light d-none d-md-flex" id="topbar">
    <div class="container-fluid container-boxed">
      <div class="navbar-user ml-auto">
        <router-link tag="button" type="button" class="btn" :to="{ name: 'logout' }">
          <font-awesome :icon="['far', 'sign-out']"/>
          Sign Out
        </router-link>
      </div><!-- /.navbar-user -->
    </div><!-- /.container-fluid -->
  </nav><!-- /#topbar -->
</template>

<script>
export default {
  methods: {
  }
}
</script>
